const centered = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const flexCentered = {
  centered,
  centeredRow: {
    ...centered,
    flexDirection: "row",
  },
  centeredColumn: {
    ...centered,
    flexDirection: "column",
  },
  centeredWithText: {
    ...centered,
    flexDirection: "column",
    textAlign: "center",
  },
  centeredColumnReverse: {
    ...centered,
    flexDirection: "column-reverse",
  },
  centeredRowReverse: {
    ...centered,
    flexDirection: "row-reverse",
  },
};

export const flex = {
  ...flexCentered,
  flexRow: {
    flexDirection: "row",
  },
  flexColumn: {
    flexDirection: "column",
  },
};
